import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';

// eslint-disable-next-line max-len
import { SkillLevelQuestionnaireAnswerList } from '@models/Questionnaire/SkillLevelQuestionnaireAnswerListModel';
// eslint-disable-next-line max-len
import { useSkillLevelQuestionnaireModel } from '@models/Questionnaire/SkillLevelQuestionnaireModel';
import { OptionItem, Separator } from '@components';

interface ISkillLevelQuestionnaireAnswersProps {
  list: SkillLevelQuestionnaireAnswerList;
}

export const SkillLevelQuestionnaireAnswers =
  observer<ISkillLevelQuestionnaireAnswersProps>(({ list }) => {
    const skillLevelQuestionnaire = useSkillLevelQuestionnaireModel();

    return (
      <Fragment>
        {list.asArray.map((answer, index) => {
          const isLastItem = index === list.asArray.length - 1;
          const isActive =
            answer.id === skillLevelQuestionnaire.selectedAnswerId;

          return (
            <Fragment key={answer.id}>
              <OptionItem
                onValueChange={() =>
                  skillLevelQuestionnaire.setSelectedAnswer(answer.id)
                }
                text={answer.text}
                value={isActive}
              />
              {!isLastItem && <Separator size="$6" />}
            </Fragment>
          );
        })}
      </Fragment>
    );
  });
